import React from 'react'
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
const Register=()=>{
const [email, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [itiid, setItiid] = useState("");
  const [tradeid, setTradeid] = useState("");
  const [fullname, setFullname] = useState("");
const [mobilenu, setMobile] = useState("");
  const navigate = useNavigate();
const handleLogin = async () => {
  const res = await fetch("http://localhost:5000/api/createuser", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
       ITI_ID:itiid,
    TRADE_ID:tradeid,
    FULL_NAME:fullname,
    TYPE:"STUDENT",
    MO_NUMBER:mobilenu,
     EMAIL:email,
    PASSWORD:password,
    LANGUAGE_ID:1
    })
  });
  const data = await res.json();    
    if (data.res === "success") {
      alert("User Creates");
        navigate("/");   // ✅ REDIRECT
    } else {
      alert("User already exist");
    }
  };
  return (
    <div>
      <input
        placeholder="Email id"
        onChange={(e) => setUsername(e.target.value)}
      />

      <input
        type="password"
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)}
      />
      <input
        type="ITI ID"
        placeholder="itiid"
        onChange={(e) => setItiid(e.target.value)}
      />


      <input
        type="Trade ID"
        placeholder="tradeid"
        onChange={(e) => setTradeid(e.target.value)}
      />

      
      <input
        type="Full NAme"
        placeholder="fullname"
        onChange={(e) => setFullname(e.target.value)}
      />

      
      <input
        type="Mobile Number"
        placeholder="mobilenu"
        onChange={(e) => setMobile(e.target.value)}
      />
      <button onClick={handleLogin}>Create User</button>
    </div>
  );
}
export default Register